import Worklist from "components/Worklist/Worklist";

export default function WorklistView() {
  return <Worklist />;
}
